import React, { useEffect, useState } from 'react'
import { notify } from '../toast';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import Modal from 'react-modal';
import '../../styles/dashboard.css';

const AdminHospitals = () => {

    const [hospitals, setHospitals] = useState([]);
    const [totalHospitals, setTotalHospitals] = useState(1);

    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteModalData, setDeleteModalData] = useState({});

    const [pageLoading, setPageLoading] = useState(false);

    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        if (hospitals.length === 0) fetchUnapprovedHospitals();

        // eslint-disable-next-line
    }, [hospitals]);


    const fetchUnapprovedHospitals = async () => {
        try {

            if (totalHospitals === hospitals.length) return notify('info', 'End of list reached');

            setPageLoading(true);

            const response = await axiosPrivate.get(`/admin/getUnapprovedHospitals?page=${Math.ceil(hospitals.length / 10) + 1}`);

            const data = response?.data
            setHospitals(prev => [...prev, ...data?.unapprovedHospitals]);
            setTotalHospitals(data?.total);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setPageLoading(false);
        }
    }

    const handleApprove = async (id) => {
        try {
            const result = await axiosPrivate.post(`/admin/approveHospital/${id}`);
            notify('success', result?.data?.success)
            setHospitals([]);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    };

    const handleReject = async (id) => {
        try {
            const result = await axiosPrivate.delete(`/admin/deleteHospital/${id}`);
            notify('success', result?.data?.success)
            setHospitals([]);

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    };

    return (
        <div className='container'>

            {// @ts-ignore
                hospitals.length !== 0 ?

                    <section className="user-list">
                        <div className="list-header">
                            <span>Name</span>
                            <span>Area</span>
                            <span>Email</span>
                            <span>Doctor count</span>
                            <span>Action</span>
                        </div>

                        <div className="list-body">
                            {// @ts-ignore
                                hospitals.map((hospital) => (
                                    <div className="list-row" key={hospital?._id}>
                                        <span className='truncate' title={hospital?.name} data-label="Name" >{hospital?.name}</span>
                                        <span className='truncate' title={hospital?.area} data-label="Area">{hospital?.area}</span>
                                        <span className='truncate' title={hospital?.email} data-label="Email">{hospital?.email}</span>
                                        <span className='truncate' title={hospital?.doctors?.length} data-label="Doctor count">{hospital?.doctors?.length || 0}</span>
                                        <span>
                                            <button className="approve-btn" onClick={() => handleApprove(hospital?._id)}>Approve</button>&nbsp;
                                            <button
                                                className="close-btn"
                                                style={{ padding: '7px 10px' }}
                                                onClick={() => {
                                                    setDeleteModalData({ subject: hospital?.name, delete: handleReject, id: hospital?._id });
                                                    setOpenDeleteModal(true);
                                                }}
                                            >
                                                Reject
                                            </button>
                                        </span>
                                    </div>
                                ))
                            }
                        </div>

                        <Modal
                            isOpen={openDeleteModal}
                            onRequestClose={() => setOpenDeleteModal(false)}
                            style={{
                                overlay: { backgroundColor: "rgba(0,0,0,0.4)" },
                            }}
                            className='formContainer'
                        >
                            <div className='formWrapper'>
                                <h2 className='formTitle'>Do you want to delete&nbsp;
                                    {// @ts-ignore
                                        deleteModalData?.subject}?</h2>
                                <div className='formRow'>
                                    <button
                                        className='close-btn'
                                        style={{ width: '95%' }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setOpenDeleteModal(false);
                                            setDeleteModalData({})
                                        }}>
                                        <span>Close</span>
                                    </button>
                                    <button className="submitButton" onClick={() => {
                                        // @ts-ignore
                                        deleteModalData?.delete(deleteModalData?.id);
                                        setOpenDeleteModal(false);
                                    }}>Delete</button>
                                </div>
                            </div>
                        </Modal >

                    </section>
                    :
                    <p><i>No hospitals need to be approved</i></p>
            }

            {totalHospitals !== hospitals.length ?
                <div>
                    <button
                        className='add-btn'
                        disabled={pageLoading}
                        onClick={fetchUnapprovedHospitals}>
                        {pageLoading ? <span className='spinner' /> : 'Load more'}
                    </button>
                </div>
                : <></>
            }

        </div>
    )
}

export default AdminHospitals
